import { Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { useHistory } from 'react-router-dom';

export interface SurveyTooltipContentProps {
  onLinkClick?: () => void;
}

export const SurveyTooltipContent = ({
  onLinkClick = () => {},
}: SurveyTooltipContentProps = {}) => {
  const history = useHistory();

  const handleCreateClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    onLinkClick();
    history.push('/settings/survey');
  };

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <KText size="sm-medium" color="white">
        No surveys created yet.{' '}
        <KText
          as="span"
          size="sm-medium"
          color="white"
          textDecoration="underline"
          cursor="pointer"
          onClick={handleCreateClick}
        >
          Create one here
        </KText>{' '}
        or contact an admin.
      </KText>
    </Box>
  );
};
